"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isHexString = void 0;
var v1_1 = __importDefault(require("./v1"));
var v2_1 = __importDefault(require("./v2"));
var isHexString = function (value) {
    if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) {
        return false;
    }
    return true;
};
exports.isHexString = isHexString;
function walletConnect(options) {
    var version = (options && options.version) || 1;
    return version === 1 ? (0, v1_1["default"])(options) : (0, v2_1["default"])(options);
}
exports["default"] = walletConnect;
